export const agentWebsiteLang = [
  { label: "English", value: "english" },
  { label: "Spanish", value: "spanish" },
  { label: "Other", value: "other" },
];

export const webRequire = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
  { label: "N/A", value: "na" },
];

export const nativeAppPlatform = [
  { label: "IOS (Apple)", value: "ios" },
  { label: "Android", value: "android" },
];

export const appPublish = [
  { label: "i2c will publish the mobile apps", value: "i2c" },
  { label: "Client will publish the mobile apps", value: "client" },
]; 

export const tollFreeOptions = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
  {label: "N/A", value: "na" },
];

export const dialingOptions = [
  { label: "TFN (Toll Free Number)", value: "toll-free-number" },
  { label: "DID (Direct Inward Dialing)", value: "direct-inward-dialing" },
  { label: "ITFS (International Toll-Free Service)", value: "international-toll-free-service" },
  { label: "UIFN", value: "uifn" },
  { label: "Other", value: "other" },
];

export const resporgOptions = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
  { label: "N/A", value: "na" },
];

export const expectedOperationHours = [
  { label: "24/7", value: "24_7" },
  { label: "Other", value: "other" },
];

export const backUporOverflowOptions = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
];
export const hostVirtualCardOptions = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" },
  { label: "N/A", value: "na" },
];

export const technologySpecOptions = [
  { label: "Web Application", value: "web-application" },
  { label: "IOS Native", value: "ios-native" },
  { label: "Android Native", value: "android-native" },
  { label: "Other", value: "other" },
];
 
export const technologySpecforMobileSDKOptions = [
  { label: "IOS Native", value: "ios-native" },
  { label: "Android Native", value: "android-native" },
  { label: "React Native", value: "react-native" },
  { label: "Flutter", value: "flutter" },
  { label: "Other", value: "other" },
];